var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.033,
    height: 19.015,
    viewBox: "0 0 20.033 19.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20637",
    "data-name": "Group 20637",
    transform: "translate(-8898 2721)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(8898 -2721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20687",
    "data-name": "Path 20687",
    d: "M25.056,13.679H22.34a.34.34,0,0,1,0-.679h2.716a.34.34,0,0,1,0,.679Zm1.358,1.7H22.34a.34.34,0,0,1,0-.679h4.075a.34.34,0,1,1,0,.679Zm0,1.7H22.34a.34.34,0,0,1,0-.679h4.075a.34.34,0,1,1,0,.679Z",
    transform: "translate(-16.228 -9.944)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20688",
    "data-name": "Path 20688",
    d: "M13.688,14.377a1.188,1.188,0,1,1,1.188-1.188.34.34,0,0,1-.679,0,.509.509,0,1,0-.509.509.34.34,0,0,1,0,.679Z",
    transform: "translate(-9.953 -9.284)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20689",
    "data-name": "Path 20689",
    d: "M13.688,14.754A1.188,1.188,0,0,1,12.5,13.565a.34.34,0,1,1,.679,0,.509.509,0,1,0,.509-.509.34.34,0,1,1,0-.679,1.188,1.188,0,1,1,0,2.377Zm0-3.4a.34.34,0,0,1-.34-.34V10.34a.34.34,0,1,1,.679,0v.679A.34.34,0,0,1,13.688,11.358Z",
    transform: "translate(-9.953 -7.963)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20690",
    "data-name": "Path 20690",
    d: "M15.34,23.358a.34.34,0,0,1-.34-.34V22.34a.34.34,0,0,1,.679,0v.679A.34.34,0,0,1,15.34,23.358Z",
    transform: "translate(-11.605 -15.888)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20691",
    "data-name": "Path 20691",
    d: "M20.149,30.679H15.056a.34.34,0,1,1,0-.679h5.093a.34.34,0,0,1,0,.679Zm-6.451,0H12.34a.34.34,0,0,1,0-.679H13.7a.34.34,0,1,1,0,.679Zm3.056,2.037H12.34a.34.34,0,1,1,0-.679h4.414a.34.34,0,1,1,0,.679Zm3.4,0H18.112a.34.34,0,1,1,0-.679h2.037a.34.34,0,1,1,0,.679Zm-2.716,2.037H12.34a.34.34,0,1,1,0-.679h5.093a.34.34,0,1,1,0,.679Z",
    transform: "translate(-9.623 -21.172)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20692",
    "data-name": "Path 20692",
    d: "M32.358,42.679H31.34a.34.34,0,1,1,0-.679h1.019a.34.34,0,0,1,0,.679Z",
    transform: "translate(-22.172 -29.097)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20693",
    "data-name": "Path 20693",
    d: "M16.075,48.679H12.34a.34.34,0,1,1,0-.679h3.735a.34.34,0,1,1,0,.679Zm3.735,0H17.433a.34.34,0,1,1,0-.679H19.81a.34.34,0,1,1,0,.679Z",
    transform: "translate(-9.623 -33.06)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20695",
    "data-name": "Path 20695",
    d: "M18.242,23.015H6.7a1.7,1.7,0,0,1-1.7-1.7V5.7A1.7,1.7,0,0,1,6.7,4H15.57a1.694,1.694,0,0,1,1.3.611L19.546,7.82a1.7,1.7,0,0,1,.394,1.087v3.7a.34.34,0,1,1-.679,0v-3.7a1.023,1.023,0,0,0-.238-.652L16.352,5.046a1.019,1.019,0,0,0-.782-.367H6.7A1.019,1.019,0,0,0,5.679,5.7V21.317A1.019,1.019,0,0,0,6.7,22.336H18.242a.346.346,0,0,0,.053,0,.345.345,0,0,1,.059-.005.25.25,0,0,0,.05-.007.34.34,0,0,1,.166.658,1.065,1.065,0,0,1-.17.026h-.016a1.08,1.08,0,0,1-.142.006Z",
    transform: "translate(-5 -4)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20696",
    "data-name": "Path 20696",
    d: "M34.98,11.064H32.358a1.019,1.019,0,0,1-1.019-1.019V6.81a.34.34,0,1,1,.679,0v3.236a.34.34,0,0,0,.34.34H34.98a.34.34,0,1,1,0,.679Zm.774,13.922a4.754,4.754,0,1,1,4.754-4.754A4.754,4.754,0,0,1,35.754,24.986Zm0-8.828a4.075,4.075,0,1,0,4.075,4.075A4.075,4.075,0,0,0,35.754,16.157Z",
    transform: "translate(-20.474 -6.31)",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20698",
    "data-name": "Path 20698",
    d: "M82.193,97.142a.377.377,0,0,1-.335-.2A3.266,3.266,0,0,0,80.7,95.494a.375.375,0,0,1,.3-.688,3.053,3.053,0,0,1,1.13,1.115,5.661,5.661,0,0,1,3.123-2.9.377.377,0,0,1,.249.712,5.233,5.233,0,0,0-2.954,3.144.377.377,0,0,1-.326.267Z",
    transform: "translate(8830.014 -2802.074)",
    fill: "#363636"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/Invoices.f4b9b4f5d7d7978de5b52fd0fff13c7f.svg";
export { ForwardRef as ReactComponent };